import ProfessionsSection from "@/components/ProfessionsSection";

const ProfessionsPage = () => {
    return (
        <main className="min-h-screen bg-background pt-10">
            <ProfessionsSection />
        </main>
    );
};

export default ProfessionsPage;
